import {Auth} from 'aws-amplify';

import UserBase from '../views/User/Layout.vue';

import Feed from '../views/User/Feed.vue';
import Events from '../views/User/Events/List.vue';
import Event from '../views/User/Events/Details.vue';

function mustBeUser(to: any, from: any, next: any) {
  Auth.currentAuthenticatedUser().then((user) => {
    if (user.signInUserSession.idToken.payload['cognito:groups']) {
      const role = user.signInUserSession.idToken.payload['cognito:groups'][0];
      if (role === 'Admin') {
        return next({name: 'AdminBase'});
      }
    }
    return next();
  }).catch(() => {
    return next({name: 'SignIn'});
  });
}

export default [
  {
    path: '/user',
    name: 'UserBase',
    component: UserBase,
    beforeEnter: mustBeUser,
    redirect: {name: 'UserFeed'},
    children: [
      {
        path: 'feed',
        name: 'UserFeed',
        component: Feed,
      },
      {
        path: 'events',
        name: 'UserEvents',
        component: Events,
      },
      {
        path: 'events/:id',
        name: 'UserEvent',
        props: true,
        component: Event,
      },
    ],
  },
];
